'use client';

import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { FC } from 'react';

import { useCartStore } from '@/features/cart';
import { SITE_PAGES } from '@/shared/config';
import { MODAL_TYPES } from '@/widgets/modals/config/constants';
import { useModalStore } from '@/widgets/modals/model/store';

const CheckoutButton: FC = () => {
  const router = useRouter();
  const { items, needsSync, syncError } = useCartStore();
  const { openModal } = useModalStore();

  const hasUnavailableItems = items.some(
    (item) => !item.selectedPrice.is_available,
  );

  const handleClick = () => {
    if (hasUnavailableItems) {
      openModal(MODAL_TYPES.confirmRemove);
    } else {
      router.push(SITE_PAGES.checkout);
    }
  };

  return (
    <button
      className={classNames('button button--md-black')}
      disabled={needsSync || !!syncError}
      onClick={handleClick}
    >
      Оформление заказа
    </button>
  );
};

export default CheckoutButton;
